import { t } from "@/i18n-js/instance";
import { Typography } from "@circle-react-shared/uikit/Typography";

interface MemberListingCardProps {
  count: number;
  members: Array<{ name: string; email: string }>;
}

export const MemberListingCard = ({
  count,
  members,
}: MemberListingCardProps) => (
  <div
    className="bg-primary border-primary flex w-[368px] min-w-0 flex-1 flex-col items-start gap-3 self-stretch rounded-2xl border p-4"
    style={{ boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)" }}
  >
    <Typography.BodySm weight="font-bold" color="text-dark">
      {t("help_widget.copilot.chat_card.members_matching", { count })}
    </Typography.BodySm>

    <div className="flex flex-col gap-2">
      {members && members.length > 0 ? (
        members.map(
          (member: { name: string; email: string }, index: number) => (
            <Typography.BodySm key={member.email} color="text-dark">
              <span className="font-bold">
                {index + 1}. {member.name}
              </span>
              , {member.email}
            </Typography.BodySm>
          ),
        )
      ) : (
        <Typography.BodySm color="text-tertiary">
          {t("help_widget.copilot.chat_card.no_members_found")}
        </Typography.BodySm>
      )}
    </div>
  </div>
);
